"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftActionsSection = void 0;
var _useTranslations = require("../../hooks/useTranslations");
var _BurgerMenuToggle = require("../BurgerMenu/BurgerMenuToggle");
var _OriflameLogo = require("../OriflameLogo");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LeftActionsSection = () => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LeftActionsSectionRoot, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuToggle.BurgerMenuToggle, {
        "aria-label": translations.menu
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OriflameLogo.OriflameLogo, {})]
  });
};
exports.LeftActionsSection = LeftActionsSection;